import React from 'react';
import styled from 'styled-components';

import WidgetHeader from './WidgetHeader';
import Placeholder from './Placeholder';
import Button from './Button';
import Icon from './Icon';

function NoDataWidget({title, options, id, preview, question, unPin}) {
  if(preview) {
    options = null;
  }

  let children = [];
  let filteredOptions = options;
  if(question !== undefined) {
    if(question.pinned) {
      children.push(
        <Button id={`${id}_pin`} tertiary onClick={() => unPin(question)}>
          <Icon name="go-pin" />
        </Button>
      )
      filteredOptions = options.filter(option => option.title !== "Pin");
    }
  }

  return (
    <React.Fragment>
      <WidgetHeader title={title} options={filteredOptions} id={id} children={children}/>
      <Container>
        <Placeholder height="100%">There is no data to display!</Placeholder>
      </Container>
    </React.Fragment>
  );
}

const Container = styled.div`
  padding: 0 1.875rem 1.875rem 1.875rem;
  height: 90%;
`;

export default NoDataWidget;